import { Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SanitizeService {
  constructor(private sanitizer: DomSanitizer) {}

  getBunnyVideoUrl(video: any): SafeResourceUrl {
    if (video && video.iframeUrl) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(video.iframeUrl);
    }
    if (video && video.videoUrl) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(video.videoUrl);
    }
    if (typeof video === 'string' && video) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(video);
    }
    if (video && video.data && typeof video.data === 'string') {
      return this.sanitizer.bypassSecurityTrustResourceUrl(video.data);
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl('');
  }
}
